<template>
  <div
    v-if="!esProduct?.isSale && !(storeConfig?.enable_savings_discount === '0')"
    class="savings-discount-notice"
  >
    <iconInfo
      class="icon icon--info"
      filled
    />
    <span class="savings-discount-notice__label">
      {{ $t('Receive {savings} savings discount on your MyDeleye', { savings: formattedSavings }) }}
    </span>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  prices: any
}>()

const esProduct = inject('esProduct', null)

const { storeConfig, fetchStoreData } = useStore()
await fetchStoreData()

const { t: $t, n } = useI18n()

const savings = computed(() => {
  const { finalPrice } = props.prices
  return finalPrice ? finalPrice * 0.05 : 0
})

const formattedSavings = computed(() => n(savings.value, 'currency'))
</script>

<style>
  @import url("~layers/app/components/Product/SavingsDiscount.css");
</style>
